import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
@Component({
  selector: 'app-print-dispatch',
  templateUrl: './print-dispatch.component.html',
  styleUrls: ['./print-dispatch.component.scss'],
})
export class PrintDispatchComponent implements OnInit {
  @Input() user: any;
  @Input() formMethod: any;
  @Input() title: any;
  @Input() paymentAmount: any;
  @Input() paymentTax: any;
  @Input() typeOrden: any;
  @Input() orderTax: any;
  @Input() taxOrden: any;
  @Input() originalPrice: any;
  @Input() taxPayment: any;
  @Input() currencyBaseName: any;
  @Input() createdAt: any;
  @Input() deliveryDate: any;
  // NUEVOS
  @Input() balanceSv: any;
  @Input() showDispatch: any;
  @Input() methodsTax: any;

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    console.log('user :>> ', this.user);
  }

  async printInfo() {
    // window.print();
    await this.modalController.dismiss();
  }
}
